import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LocationService } from '../location.service';
import { SearchIpdPatientLocationComponent } from './search-ipd-patient-location/search-ipd-patient-location.component';
import { takeUntil } from 'rxjs/operators';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { Subject } from 'rxjs';
import { ipdLocationModel } from 'app/masters/models/branch-master.model';

@Component({
  selector: 'app-ipd-patient-location-master',
  templateUrl: './ipd-patient-location-master.component.html',
  styleUrls: ['./ipd-patient-location-master.component.scss']
})
export class IpdPatientLocationMasterComponent implements OnInit {
  destroyipdLocation$: Subject<boolean> = new Subject<boolean>();
  ipdlocationmodel: ipdLocationModel = {}
  enabledisablebtn: boolean = true;
  constructor(public dialog: MatDialog,
    public locationService: LocationService,
    private dashboardService: DashboardService,
  ) { }

  ngOnInit(): void {
    this.IPDLocationMaster(0);
    this.ipdlocationmodel.isActive = false;
  }

  IPDLocationMaster(id) {
    this.locationService.GetIPDLocationMaster(id).pipe(takeUntil(this.destroyipdLocation$)).subscribe((res) => {
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message,"OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

 enableButton() {
  const categoryName = this.ipdlocationmodel.categoryName?.toString().trim();
  const iconName = this.ipdlocationmodel.iconName?.toString().trim();

  if (!categoryName || categoryName === '' || !iconName || iconName === '') {
    this.enabledisablebtn = true;
  } else {
    this.enabledisablebtn = false;
  }
}

  saveIPDLocationMaster() {
    if (!this.ipdlocationmodel.categoryName) {
      this.dashboardService.openSnackBar(" Please Select Category Name", "OK");
      return;
    }
    if (!this.ipdlocationmodel.categoryCode) {
      this.dashboardService.openSnackBar(" Please Select Category Code", "OK");
      return;
    }
    if(!this.ipdlocationmodel.iconName){
            this.dashboardService.openSnackBar(" Please Select Icon Name", "OK");
            return
    }
    
    const InsertIPDLocation = {
      "PK_TranId": this.ipdlocationmodel.pK_TranId ? this.ipdlocationmodel.pK_TranId : 0,
      "LocationName": this.ipdlocationmodel.categoryName,
      "LocationColorCode": this.ipdlocationmodel.categoryCode,
      "IsActive": this.ipdlocationmodel.isActive,
      "ColWidth": this.ipdlocationmodel.colWidth,
      "SeqNo": this.ipdlocationmodel.seqNo,
      "ShortName": this.ipdlocationmodel.shortName,
      "WebForeColor": this.ipdlocationmodel.webForeColor,
      "WebBackColor": this.ipdlocationmodel.webBackColor,
      "IconName": this.ipdlocationmodel.iconName,
      "IsEdit": this.ipdlocationmodel.pK_TranId ? true : false
    }
    let payload = {
      InsertIPDLocationMasterDto: InsertIPDLocation
    }

    this.locationService.InsertIPDLocationMaster(payload).pipe(takeUntil(this.destroyipdLocation$)).subscribe((x) => {
       if (x['statusCode'] == 10) {this.dashboardService.openSnackBar("This record is already exists","OK");}
      if (x['statusCode'] == 1) {
        this.IPDLocationMaster(0);
        this.dashboardService.openSnackBar(InsertIPDLocation.PK_TranId == 0 ? "Record Saved Successfully" : "Record Updated Successfully", "OK");
        this.reset();
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message,"OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  reset() {
    this.ipdlocationmodel.categoryName = null;
    this.ipdlocationmodel.categoryCode = null;
    this.ipdlocationmodel.iconName = null;
    this.ipdlocationmodel.isActive = false;
    this.ipdlocationmodel.webForeColor = "";
    this.ipdlocationmodel.pK_TranId = null;
  }

  updateCategoryCode(hex: string): void {
    const hexValue = hex.replace('#', '');
    const r = parseInt(hexValue.substring(0, 2), 16);
    const g = parseInt(hexValue.substring(2, 4), 16);
    const b = parseInt(hexValue.substring(4, 6), 16);
    this.ipdlocationmodel.categoryCode = `${r}${g}${b}`;
  }

  /** Search IPD Patient Location Master */
  searchIPDpatLocationMaster() {
    const dialogRef = this.dialog.open(SearchIpdPatientLocationComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "50%",
      width: "50%",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.ipdlocationmodel.categoryName = result.categoryName;
        this.ipdlocationmodel.categoryCode = result.categoryCode;
        this.ipdlocationmodel.pK_TranId = result.pK_TranId;
        this.ipdlocationmodel.isActive = result.isActive;
        this.ipdlocationmodel.shortName = result.shortName;
        this.ipdlocationmodel.colWidth = result.colWidth;
        this.ipdlocationmodel.iconName = result.iconName;
        this.ipdlocationmodel.sample = result.sample;
        this.ipdlocationmodel.seqNo = result.seqNo;
        this.ipdlocationmodel.webBackColor = result.webBackColor;
        this.ipdlocationmodel.webForeColor = result.webForeColor;
        this.enableButton();
      }
    });
  }


  ngOnDestroy() {
    this.destroyipdLocation$.next(true);
    this.destroyipdLocation$.unsubscribe();
  }
}
